import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { harwinConfirm } from "./utils/harwinConfirm";


window.harwinConfirm = harwinConfirm;
window.harwinFileName = (type, name = "", branch = "", ext = "pdf", date = new Date()) => {
  const pad = (n) => String(n).padStart(2, "0");
  const d = date instanceof Date && !Number.isNaN(date.getTime()) ? date : new Date();
  const dateText = `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
  const clean = (v) => String(v || "").trim().replace(/[\\/:*?"<>|]+/g, "-").replace(/\s+/g, "_").replace(/_+/g, "_").replace(/^[_-]+|[_-]+$/g, "");
  const parts = [clean(type), clean(name), clean(branch), dateText].filter(Boolean);
  return `${parts.join("_")}.${String(ext || "pdf").replace(/^\./, "")}`;
};

// ERP-wide user-message bridge: legacy window.alert calls render as non-blocking toasts.
// Technical HTTP/Axios wording is never exposed when a useful business message is unavailable.
const cleanUserMessage = (value) => {
  const message = String(value || "").trim();
  if (!message) return "Something went wrong. Please try again.";
  if (/request failed with status code|axioserror|internal server error|network error/i.test(message)) {
    return "Something went wrong. Please try again.";
  }
  return message;
};
window.harwinNotify = (message, preferredType) => {
  const clean = cleanUserMessage(message);
  const inferredSuccess = /success|saved|created|updated|deleted|completed|generated|downloaded|sent/i.test(clean) && !/failed|error|unable|cannot|invalid/i.test(clean);
  const type = preferredType || (inferredSuccess ? "success" : "error");
  const notify = type === "success" ? toast.success : type === "warning" ? toast.warning : type === "info" ? toast.info : toast.error;
  notify(clean, { position: "top-right", autoClose: 3500 });
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
